import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import { getIsShortStatus, getStatusBackgroundProps, styleFromWidthHeight, getTextDumboTypeBySize } from '../../_helpers';
import ExcerptRenderer from '../../../TextRenderer/ExcerptRenderer';
import Background from '../../../Background';
import s from './Status.scss';
export const StatusDumbView = ({ deviation , width , height , className , 'aria-hidden': ariaHidden , responsive =true  })=>{
    const { t  } = useTranslation();
    const { textContent  } = deviation;
    if (!textContent) {
        return null;
    }
    const type = getTextDumboTypeBySize(height || width);
    const style = styleFromWidthHeight({
        width,
        height
    }, responsive);
    const backgroundProps = getStatusBackgroundProps(deviation);
    return /*#__PURE__*/ React.createElement(Section, {
        style: style
    }, /*#__PURE__*/ React.createElement(Background, _extends({
        className: classnames(s['root'], s[type], getIsShortStatus(deviation, true) ? s['short'] : s['long'], className),
        contentClassName: s[`content-${type}`],
        width: width,
        height: height,
        variant: "status"
    }, backgroundProps), /*#__PURE__*/ React.createElement("div", {
        className: s['body'],
        "aria-hidden": ariaHidden
    }, /*#__PURE__*/ React.createElement(ExcerptRenderer, {
        className: s['body-inner'],
        textContent: textContent,
        htmlExcerptLegacy: true,
        emptyPlaceHolder: `[${t('deviationview.unknown.nopreview')}]`
    }))));
};
StatusDumbView.displayName = 'StatusDumbView';
export default StatusDumbView;
